import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import React, { useState } from "react";
import { connect } from "react-redux";

declare global {
    interface Window {
        Cookiebot?: {
            consent: {
                necessary: boolean
                statistics: boolean
                marketing: boolean
            }
            hasResponse: boolean
        }
    }
}

interface CustomSettingsModel {
    marketingSiteUrl: string;
}

type Props = ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => {
    const settingsCollection = getSettingsCollection(state);
    const customSettings = settingsCollection?.customSettingsSettings as CustomSettingsModel;

    return {
        marketingSiteUrl: customSettings.marketingSiteUrl,
        currentLanguage: state.context.session.language,
    };
};

const CookieBot = ({ currentLanguage, marketingSiteUrl }: Props) => {
    const [domainGroupId, setDomainGroupId] = useState<string | null>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const getDomainGroupId = async (): Promise<string | null> => {
        try {
            const res = await fetch(`${marketingSiteUrl}/umbraco/api/SonicApi/GetCookiebotId`);
            if (res.ok) {
                const repsonse = await res.text();
                return repsonse;
            }
            return "";
        } catch (error) {
            return null;
        }
    };

    const cookiebotLocale = GetCookiebotLocale();

    try {
        if (typeof window === "undefined") {
            return null;
        }
    } catch (e) {
        console.log(e);
    }

    getDomainGroupId().then(id => {
        setDomainGroupId(id);
        setIsLoading(false);
    });

    if (isLoading) {
        return <div></div>;
    }

    if (domainGroupId === "" || domainGroupId === null) {
        // eslint-disable-next-line no-console
        console.log("domainGroupId not set...");
        return null;
    }

    if (document.getElementById("CookieBot") !== null) {
        return null;
    }

    window.addEventListener("CookiebotOnAccept", function () {
        HandleCookieDecision(window.Cookiebot?.consent);
    });

    window.addEventListener("CookiebotOnDecline", function () {
        HandleCookieDecision(window.Cookiebot?.consent);
    });

    const script = document.createElement("script");
    script.setAttribute("id", "CookieBot");
    script.setAttribute("src", "https://consent.cookiebot.com/uc.js");
    script.setAttribute("data-cbid", domainGroupId ?? "");
    script.setAttribute("data-blockingmode", "auto");
    script.setAttribute("type", "text/javascript");

    if (cookiebotLocale) {
        script.setAttribute("data-culture", cookiebotLocale);
    }

    const head = document.querySelector("html > head")!;
    if (typeof head === "undefined") {
        return null;
    }
    head.insertBefore(script, head.firstChild);
    return (
        <script
            id="CookieDeclaration"
            src={`https://consent.cookiebot.com/${domainGroupId}/cd.js`}
            type="text/javascript"
            data-blockingmode="auto"
        />
    );

    // Translate the umbraco culture to one that cookiebot accepts.
    // Default is english locale.
    function GetCookiebotLocale() {
        const umbracoLocale = currentLanguage?.cultureCode ?? "EN";

        return umbracoLocale.split("-")[0].toUpperCase();
    }

    function SetCookie(name: string, value: string) {
        document.cookie = `${name}=${value}; max-age=31536000; SameSite=None; Secure;Path=/;`;
    }

    function HandleCookieDecision(consent: any) {
        SetCookie("cookie-necessary-0", consent.necessary);
        SetCookie("cookie-statistics-0", consent.statistics);
        SetCookie("cookie-marketing-0", consent.marketing);
        if (consent.statistics) {
            (window as any).clarity?.("consent");
        }
    }
};

export default connect(mapStateToProps)(CookieBot);
